import React from "react";

import { ScoreComparison } from "~/sdks/LocalContent/components/ScoreComparison";
import { ScoreText } from "~/sdks/LocalContent/components/ScoreText";
import { ScorePoiList } from "~/sdks/LocalContent/components/ScorePoiList";
import type { MarkerValue } from "~/sdks/LocalContent/components/ScorePoiList/types";

import {
  type POISubcategory,
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useTracking } from "@local-logic/core/tracking";
import { useRootElement } from "../context";

import { Header } from "./Header";

import * as styles from "./styles";

export function ScoreDetails() {
  const {
    isExpanded,
    isMarkersLoading,
    activeScore,
    activeScoreData,
    markersData,
  } = useRootElement();
  const tracking = useTracking();

  const handleOnPOISelected = (poi: MarkerValue, category: POISubcategory) => {
    if (activeScore === null) {
      return;
    }

    const eventAttributes: Record<string, boolean | string | number> = {
      score: activeScore,
      category,
    };

    Object.entries(poi).forEach(([key, value]) => {
      if (["boolean", "string", "number"].includes(typeof value)) {
        eventAttributes[key] = value;
      }
    });

    tracking.postEvent({
      eventType: TrackingPipelineEvents.SIDEBAR_POI_SELECTED,
      eventAttributes: Object.entries(eventAttributes).map(([key, value]) => ({
        label: key,
        data: value,
      })),
    });

    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.SIDEBAR_POI_SELECTED,
      eventAttributes,
    });
  };

  if (!isExpanded) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="sidebar-score-details">
      <Header scoreKey={activeScore} scoreValue={activeScoreData?.value} />
      <ScoreComparison
        scoreKey={activeScore}
        locationScoreValue={activeScoreData?.value}
        comparedTo={activeScoreData?.geographies?.g30}
      />
      <ScoreText text={activeScoreData?.text} />
      <ScorePoiList
        isLoading={isMarkersLoading}
        pois={markersData}
        scoreKey={activeScore}
        onPOISelected={handleOnPOISelected}
      />
    </div>
  );
}
